import { render, staticRenderFns } from "./ResultAreaForJson.vue?vue&type=template&id=80ab9820"
import script from "./ResultAreaForJson.vue?vue&type=script&lang=js"
export * from "./ResultAreaForJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports